export default __webpack_public_path__ + "static/everywhere-lab-visit-5293c7da2134f7baafa91e6dfedeb77b.jpg";